var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_box",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"next-loading-bg"},[_c('div',{staticClass:"next-loading-tip load_img"}),_c('div',{staticClass:"loading_text"},[_vm._v("加载中...")])])
}]

export { render, staticRenderFns }